module.exports = __webpack_public_path__ + "img/code.bc9008c0.png";